import { render, staticRenderFns } from "./TransactionListItem.vue?vue&type=template&id=64ea0018&"
import script from "./TransactionListItem.vue?vue&type=script&lang=js&"
export * from "./TransactionListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports